import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(props, _ref) {
    var $, $f7, $f7route, $f7router, $on, $update, translate, parent, id_children, selectChildren, user, avatar, editMedical, safeAttempts, keynumber, modified, images_, arr, macro_patologie_list, macro_patologie, setInitialValues, addMedicine, editMedicine, deleteMedicine, popupAddMedicineOpened, popupAddMedicineClosed, toggleEdit, importDocuments, enableBtnImport, clearDocumentList, clickOnDocument, openFingerprint, setSafe, safeCancel, updateFields, modified_data, updateForm, clear, save, recoveryPIN;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            $ = _ref.$, $f7 = _ref.$f7, $f7route = _ref.$f7route, $f7router = _ref.$f7router, $on = _ref.$on, $update = _ref.$update;
            translate = {
              'razza': 'razza',
              'taglia': 'size',
              'pelo': 'hair',
              'colore': 'color',
              'peso': 'weight',
              'impiego': 'use'
            };
            _context9.next = 4;
            return myApp.user();

          case 4:
            parent = _context9.sent;

            selectChildren = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var buttons;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        console.log('selectChildren');
                        buttons = [];
                        parent.data.childrens.forEach(function (item) {
                          item.avatar = item.avatar || 'static/pet.svg';
                          buttons.push({
                            text: "<img width=\"20\" src=\"".concat(item.avatar, "\"/> ").concat(item.name, " [").concat(item.lastname, "]"),
                            onClick: function onClick() {
                              return id_children = item.id;
                            }
                          });
                        });
                        $f7.dialog.create({
                          title: "".concat(lng.select, "  PET"),
                          //text: 'Dialog with vertical buttons',
                          buttons: buttons,
                          verticalButtons: true
                        }).open();
                        return _context.abrupt("return", new Promise(function (resolve, reject) {
                          window.setInterval(function () {
                            if (id_children) resolve(id_children);
                          }, 300);
                        }));

                      case 5:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function selectChildren() {
                return _ref3.apply(this, arguments);
              };
            }();

            if (myApp.children) {
              _context9.next = 18;
              break;
            }

            if (!(parent.data.childrens && parent.data.childrens.length === 1)) {
              _context9.next = 11;
              break;
            }

            myApp.children = parent.data.childrens[0].id;
            _context9.next = 18;
            break;

          case 11:
            if (!(parent.data.childrens && parent.data.childrens.length > 1)) {
              _context9.next = 17;
              break;
            }

            _context9.next = 14;
            return selectChildren();

          case 14:
            myApp.children = _context9.sent;
            _context9.next = 18;
            break;

          case 17:
            $f7.dialog.alert(lng.select_pet_message, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      // apre pagina children
                      $f7router.navigate('/children/_new/');

                    case 1:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            })));

          case 18:
            if (!myApp.children) {
              _context9.next = 24;
              break;
            }

            _context9.next = 21;
            return myApp.getChildren();

          case 21:
            _context9.t0 = _context9.sent;
            _context9.next = 25;
            break;

          case 24:
            _context9.t0 = {
              data: {
                medical: {}
              }
            };

          case 25:
            user = _context9.t0;
            user.data.medical = user.data.medical || {
              images: [],
              documents: [],
              qrcodes: [],
              medicinali_in_uso: []
            };
            user.data.medical.images = user.data.medical.images || [];
            user.data.medical.documents = user.data.medical.documents || [];
            user.data.medical.qrcodes = user.data.medical.qrcodes || [];
            user.data.medical.medicinali_in_uso = user.data.medical.medicinali_in_uso || [];
            ['documents', 'images', 'qrcodes'].forEach(function (e) {
              user.data.medical[e] = user.data.medical[e] || [];
            });
            _context9.next = 34;
            return myStorage.get(user.data.avatar);

          case 34:
            _context9.t2 = _context9.sent;

            if (_context9.t2) {
              _context9.next = 37;
              break;
            }

            _context9.t2 = user.data.avatar;

          case 37:
            _context9.t1 = _context9.t2;

            if (_context9.t1) {
              _context9.next = 40;
              break;
            }

            _context9.t1 = 'static/pet.svg';

          case 40:
            avatar = _context9.t1;
            editMedical = $f7route.query.edit || !user.data.medical.id;
            safeAttempts = 3, keynumber = [];
            modified = false; // immagini. Nuova versione

            if (user.data.medical.images.length && typeof user.data.medical.images[0] === 'string') {
              // modifica struttura image. Per retrocompatibilità.
              if (user.data.medical.images.length && typeof user.data.medical.images[0] === 'string') {
                user.data.medical.images_tags = user.data.medical.images_tags || _toConsumableArray(Array(user.data.medical.images.length));
                images_ = user.data.medical.images.map(function (item, i) {
                  return {
                    src: item,
                    name: user.data.medical.images_tags[i]
                  };
                });
                user.data.medical.images = images_;
              }
            }

            if (typeof user.data.medical.medicinali_in_uso === 'string' || user.data.medical.medicinali_in_uso instanceof String) {
              if (user.data.medical.medicinali_in_uso.length) {
                arr = user.data.medical.medicinali_in_uso.split('\n');
                user.data.medical.medicinali_in_uso = arr.map(function (i) {
                  return {
                    farmaco: i,
                    posologia: ''
                  };
                });
              } else {
                user.data.medical.medicinali_in_uso = [];
              }
            }

            macro_patologie_list = [{
              key: 'patologie_cardiache',
              caption: 'Patologie Cardiache'
            }, {
              key: 'patologie_congenite',
              caption: 'Patologie Congenite'
            }, {
              key: 'patologie_neurologiche',
              caption: 'Patologie Neurologiche'
            }, {
              key: 'patologie_oculistiche',
              caption: 'Patologie Oculistiche'
            }, {
              key: 'patologie_dermatologiche',
              caption: 'Patologie Dermatologiche – Mantello'
            }, {
              key: 'patologie_ortopediche',
              caption: 'Patologie Ortopediche'
            }, {
              key: 'patologie_metaboliche',
              caption: 'Patologie Metaboliche'
            }, {
              key: 'patologie_gastoenteriche',
              caption: 'Patologie Gastoenteriche'
            }];

            macro_patologie = function macro_patologie() {
              return macro_patologie_list.reduce(function (total, current, index, arr) {
                var k = arr[index].key;
                var ok = !!user.data.medical[k];

                if (index === 1) {
                  var k0 = arr[0].key;
                  var ok0 = !!user.data.medical[k0];
                  total = ok0;
                }

                return total === true || ok || false;
              });
            };
            /**
             * Evento di pagina: prima che la pagina sia visualizzata
             * https://framework7.io/docs/router-component.html#component-page-events
             */


            $on('pageBeforeIn', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      setInitialValues();

                      if ($f7route.query.pin === 'yes') {
                        toggleEdit();
                      }

                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            })));
            $on('pageAfterIn', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            })));
            /**
             * Evento di pagina
             * https://framework7.io/docs/router-component.html#component-page-events
             */

            $on('pageMounted', function () {
              $('.safe').on('click', function (ev) {
                setSafe($(ev.target).data('number'));
              });
            });
            /**
             * Evento di pagina
             * https://framework7.io/docs/router-component.html#component-page-events
             */

            $on('pageBeforeOut', function () {
              return save();
            });
            /**
             * Imposta valori dei campi da user.data.medical
             */

            setInitialValues = function setInitialValues() {
              $('.field').each(function (el) {
                var k = $(el).data('field');
                if (k !== 'medicinali_in_uso') $(el).val(user.data.medical[k] || '');else {
                  var t = '';
                  (user.data.medical.medicinali_in_uso || []).forEach(function (i, idx) {
                    t += '<tr><td>' + i.farmaco + '</td><td>' + i.posologia + '</td><td style="text-align:left"><a class="btn-edit" href="javascript:myApp.editFarmacoInUso(' + idx + ')"><i class="f7-icons">pencil</i></a></td>' + '</td><td style="text-align:right"><a class="btn-delete" href="javascript:myApp.deleteFarmacoInUso(' + idx + ')"><i class="f7-icons">minus_circle_fill</i></a></td></tr>';
                  });
                  $('#tbl-medicinali').html(t);
                }
              });
              $('.fieldCheckbox').each(function (el) {
                var k = $(el).data('field');
                $(el).prop('checked', user.data.medical[k] || false);
              });
              $('#sex').val(user.sex);
              $('#sterilized').val(user.sterilized);
            };
            /**
             * Aggiunge farmaco in uso alla lista
             * 
             * @returns {undefined}
             */


            addMedicine = function addMedicine() {
              if (!$f7.input.validate($('#add-farmaco') || !$f7.input.validate($('#add-posologia')))) return;
              var item = {
                farmaco: $('#add-farmaco').val(),
                posologia: $('#add-posologia').val()
              };
              var idx = $('#add-idx').val();
              idx ? user.data.medical.medicinali_in_uso[idx] = item : user.data.medical.medicinali_in_uso.push(item);
              modified = true;
              setInitialValues();
              $update();
              $f7.popup.close();
            };
            /**
             * Modifica farmaco in uso
             * 
             * @param {type} idx
             * @returns {undefined}
             */


            editMedicine = function editMedicine(idx) {
              var item = user.data.medical.medicinali_in_uso[idx];
              $('#add-farmaco').val(item.farmaco);
              $('#add-posologia').val(item.posologia);
              $('#add-idx').val(idx);
              $f7.popup.open('.popup-add-medicine');
            };
            /**
             * Elimina farmaco in uso dalla lista
             * 
             * @param {type} idx
             * @returns {undefined}
             */


            deleteMedicine = function deleteMedicine(idx) {
              $f7.dialog.confirm(lng.delete_item_message, function () {
                user.data.medical.medicinali_in_uso.splice(idx, 1);
                setInitialValues();
                $update();
              });
            };

            myApp.editFarmacoInUso = editMedicine;
            myApp.deleteFarmacoInUso = deleteMedicine;

            popupAddMedicineOpened = function popupAddMedicineOpened() {
              $('#add-farmaco').focus();
            };

            popupAddMedicineClosed = function popupAddMedicineClosed() {
              $('#add-farmaco').val('');
              $('#add-posologia').val('');
              $('#add-idx').val('');
            };
            /**
             * Mostra / nasconde sezione edit - sezione sola lettura 
             * @returns {undefined}
             */


            toggleEdit = function toggleEdit() {
              if (editMedical) save();
              editMedical = !editMedical;

              if (!user.data.medical.id) {
                $f7router.navigate('/services/');
              } else {
                $update().then(function () {
                  return setInitialValues();
                });

                if (editMedical && !myApp.secureMode) {//$f7.popup.open('.popup-safe', false);
                  //openFingerprint();
                } else {
                  keynumber = [];
                  $('#safe-message').addClass('invisible');
                  $('.point').removeClass('point-fill');
                }
              }
            };
            /**
             * Importa documenti da 'Documenti'
             * @returns {undefined}
             */


            importDocuments = function importDocuments() {
              $('.importDocument').each(function (e, i) {
                if ($(e).prop('checked')) {
                  var id = $(e).data('id');
                  var type = $(e).data('type');
                  var document = user.data.medical[type].find(function (item) {
                    return item.id == id || item.url == id || item.src == id;
                  });
                  document.viewOnMedicalRecords = true;
                  e.checked = false;
                  modified = true;
                }
              });
              $update();
            };

            enableBtnImport = function enableBtnImport() {
              $('.importDocument:checked').length ? $('.btn-import').removeClass('disabled') : $('.btn-import').addClass('disabled');
            };

            clearDocumentList = function clearDocumentList() {
              $('.importDocument').each(function (e) {
                return $(e).prop('checked', false);
              });
              $('.btn-import').addClass('disabled');
            };
            /**
             * Imposta azioni
             * 
             * @param {type} ev
             * @returns {undefined}
             */


            clickOnDocument = function clickOnDocument(ev) {
              var id = $(ev.target).data('id') || $(ev.target).parent().data('id');
              var type = $(ev.target).data('type') || $(ev.target).parent().data('type');
              var document = user.data.medical[type].find(function (e) {
                return e.id && e.id == id || e.url == id || e.src == id;
              });

              if (editMedical) {
                // modifica
                $f7.actions.create({
                  buttons: [{
                    label: true,
                    text: lng.select_action
                  }, {
                    icon: '<i class="f7-icons">pencil_ellipsis_rectangle</i>',
                    text: lng.rename,
                    color: 'blue',
                    onClick: function onClick() {
                      $f7.dialog.prompt(lng.insert + ' ' + lng.name, /*#__PURE__*/function () {
                        var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(text) {
                          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                            while (1) {
                              switch (_context5.prev = _context5.next) {
                                case 0:
                                  document.name = text + (type === 'documents' ? '.pdf' : '');
                                  modified = true;
                                  $update();

                                case 3:
                                case "end":
                                  return _context5.stop();
                              }
                            }
                          }, _callee5);
                        }));

                        return function (_x3) {
                          return _ref7.apply(this, arguments);
                        };
                      }(), false, document.name.replace(/\.pdf$/i, ''));
                    }
                  }, {
                    icon: '<i class="f7-icons">eye_slash</i>',
                    text: lng.remove_from_medical_records,
                    color: 'blue',
                    onClick: function onClick() {
                      document.viewOnMedicalRecords = false;
                      modified = true;
                      $update();
                    }
                  }, {
                    icon: '',
                    text: lng.cancel,
                    color: 'red'
                  }]
                }).open();
              } else if (document.url) {
                // visualizza documento
                myApp.iab(document.url, '_system');
              } else {
                // visualizza foto / qrcode
                var idx = user.data.medical[type].filter(function (e) {
                  return e.viewOnMedicalRecords;
                }).findIndex(function (e) {
                  return e.id == id;
                });
                $f7.photoBrowser.create({
                  photos: user.data.medical[type].filter(function (e) {
                    return e.viewOnMedicalRecords;
                  }).map(function (e) {
                    return {
                      url: e.src,
                      caption: e.name
                    };
                  })
                }).open(idx);
              }
            };
            /**
             * Login con fati biometrici (Fingerprint / Analisi del viso)
             * 
             * usa cordova-plugin-fingerprint-aio
             * cordova plugin add cordova-plugin-fingerprint-aio --variable FACEID_USAGE_DESCRIPTION="Per modificare i tuoi dati personali in sicurezza."
             * https://www.npmjs.com/package/cordova-plugin-ebw-fingerprint-aio
             * 
             * @returns {undefined}
             */


            openFingerprint = function openFingerprint() {
              if ($f7.device.cordova) {
                var isAvailableSuccess = function isAvailableSuccess() {
                  Fingerprint.show({
                    description: lng.access_with_biometric_message
                  }, successCallback, function (errorCallback) {
                    return console.log(errorCallback);
                  });
                };

                var successCallback = function successCallback(res) {
                  myApp.enableSecure();
                  $('#safe-message').addClass('invisible');
                  $f7.popup.close('.popup-safe');
                };

                Fingerprint.isAvailable(isAvailableSuccess, function () {
                  return console.log('Fingerprint not available');
                });
              }
            };
            /**
             * Chiede e controlla PIN
             * 
             * @param {type} number
             * @returns {undefined}
             */


            setSafe = function setSafe(number) {
              if (!safeAttempts) return;

              switch (number) {
                case 'null':
                  break;

                case 'back':
                  if (keynumber.length) {
                    keynumber.pop();
                  }

                  break;

                default:
                  if (keynumber.length === 3) {
                    keynumber.push(number);
                    var ok = true;
                    user.pin = user.pin || [];
                    keynumber.forEach(function (e, i) {
                      if (e !== user.pin[i]) ok = false;
                    });

                    if (ok) {
                      $('#safe-message').addClass('invisible');
                      myApp.enableSecure();
                      $f7.popup.close('.popup-safe');
                    } else {
                      $('#safe-message').removeClass('invisible');
                      keynumber = [];
                      safeAttempts--;
                      $update();
                    }
                  } else {
                    keynumber.push(number);
                  }

              }

              $('.point').removeClass('point-fill');
              keynumber.forEach(function (e, i) {
                $('.point-' + i).addClass('point-fill');
              });
            };
            /**
             * Annulla controllo PIN
             * 
             * @returns {undefined}
             */


            safeCancel = function safeCancel() {
              $f7.popup.close('.popup-safe', false);
              toggleEdit();
            };
            /**
             * Imposta valori in user.data.medical
             * @param {type} ev
             * @returns {undefined}
             */


            updateFields = function updateFields(ev) {
              var el = $(ev.target);
              var field = el.data('field');
              user.data.medical[field] = ev.target.type === 'checkbox' ? el.prop('checked') : el.val();
              modified = true; // nome dei farmaci

              if (field.match(/^farmaco\d$/) && user.data.medical[field]) {
                $f7.dialog.prompt(lng.enter_drug_name, function (caption) {
                  if (caption) {
                    user.data.medical[field + '_caption'] = caption;
                  }
                }, false, user.data.medical[field + '_caption'] || '');
              }
            };

            modified_data = false;

            updateForm = /*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(ev) {
                var el, field;
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        el = $(ev.target);
                        field = ev.target.id;
                        console.log(field, ev.target.value);
                        user[field] = ev.target.value;
                        console.log(user);
                        modified_data = true;

                      case 6:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6);
              }));

              return function updateForm(_x4) {
                return _ref8.apply(this, arguments);
              };
            }();
            /**
             * Reimposta campi ai valori di default
             */


            clear = function clear() {
              $('.field').each(function (el) {
                el.value = '';
              });
              $('.fieldCheckbox').each(function (el) {
                $(el).prop('checked', false);
              });
            };
            /**
             * Salva 
             * @param {type} fieldsValidated
             * @returns {unresolved}
             */


            save = /*#__PURE__*/function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(fieldsValidated) {
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        if (!(!modified && !modified_data)) {
                          _context7.next = 2;
                          break;
                        }

                        return _context7.abrupt("return");

                      case 2:
                        $('.field').each(function (el) {
                          var k = $(el).data('field');
                          if (k !== 'medicinali_in_uso') user.data.medical[k] = el.type == 'checkbox' ? $(el).prop('checked') : $(el).val();
                        });
                        /**
                         * Invia oggetto medical al server e re-imposta array user.data.medical, quindi salva user (myApp.user(user);
                         */

                        $f7.preloader.show();
                        _context7.prev = 4;

                        if (!modified) {
                          _context7.next = 10;
                          break;
                        }

                        user.data.medical.id = user.data.medical.id || Date.now();
                        _context7.next = 9;
                        return myApp.server.putJSON('user/me/medical?children=' + (myApp.children || ''), user.data.medical);

                      case 9:
                        user.data.medical = _context7.sent;

                      case 10:
                        if (!modified_data) {
                          _context7.next = 13;
                          break;
                        }

                        _context7.next = 13;
                        return myApp.server.postJSON('user/me', {
                          user: user,
                          children: user.id
                        });

                      case 13:
                        _context7.next = 15;
                        return myApp.setChildren(user);

                      case 15:
                        $f7.toast.show({
                          text: lng.saved_ok,
                          cssClass: 'bg-color-green text-color-white',
                          closeTimeout: 3000
                        });
                        _context7.next = 21;
                        break;

                      case 18:
                        _context7.prev = 18;
                        _context7.t0 = _context7["catch"](4);
                        $f7.alertError(_context7.t0);

                      case 21:
                        _context7.prev = 21;
                        $f7.preloader.hide();
                        modified = false;
                        modified_data = false;
                        return _context7.finish(21);

                      case 26:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7, null, [[4, 18, 21, 26]]);
              }));

              return function save(_x5) {
                return _ref9.apply(this, arguments);
              };
            }();

            recoveryPIN = /*#__PURE__*/function () {
              var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                var phone, pin, url;
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        _context8.next = 2;
                        return myApp.server.authToken();

                      case 2:
                        phone = _context8.sent;
                        pin = user.data.pin.join('');
                        url = 'https://webapp.doctorpass.it/auth/' + lng.key + '/doctorpass/' + encodeURIComponent(phone) + '/' + btoa(pin);

                        window.recoveryPinCallback = function (pin) {
                          return console.log(pin);
                        };

                        myApp.iab(url);

                      case 7:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8);
              }));

              return function recoveryPIN() {
                return _ref10.apply(this, arguments);
              };
            }();

            return _context9.abrupt("return", function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="medical_records">
    <!-- Top Navbar -->
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left">
          <a href="#" class="link back">
            <i class="f7-icons ios-only">arrow_left</i>
            <i class="material-icons md-only">arrow_back</i>
          </a>
        </div>
        <div class="title sliding">
          ${editMedical ? $h`
          <div class="display-flex align-items-center">
            <div class="avatar-small margin-left-half" 
                 style="background-image: url(${avatar})"></div>
            <div class="padding-left">${user.name}</div>
          </div>
          ` : lng.medical_records_title }

        </div>
        <!-- Imposta modalità 'Edit' e 'Sola lettura' -->
        <div class="right">
          <a href="#" class="link icon-only" @click=${toggleEdit}>
            ${editMedical ? $h`
            <i class="icon f7-icons">pencil_slash</i>
            ` : $h`
            <i class="icon f7-icons">pencil</i>
            `}
          </a>
        </div>
      </div>
    </div>
    <!-- Scrollable page content-->
    <div class="page-content bg-color-white">

      <!-- ---------------------------
      ===== Sezione Sola lettura ===== 
      ---------------------------- -->
      ${!editMedical && $h`
      <div class="unselectable">
        <div class="avatar margin-vertical" style="background-image: url(${avatar})"></div>
        <h3 class="text-align-center">${user.name}
          <br/> <small>[${user.lastname}]</small>
        </h3>

        <div class='block mt-0'>
          <h4 class='title'>${lng.pet_data}</h4>
          <div>${lng.sex}: <span class="text-bold">${user.sex}</span></div>
          <div>${lng.birthdate}: 
            <span class="text-bold">${new Date(user.birthdate).toLocaleDateString()}</span></div>
          <div>${lng.identification_number}: <span class="text-bold">${user.chip}</span></div>
          <div>${lng.sterilized} <span class="text-bold">${user.sterilized === 'Y' ? 'Si' : 'No'}</span></div>

          ${['razza','taglia','pelo','colore','peso','impiego'].map(item => user[item] ? $h`
          <div class='text-capitalize'>${lng[translate[item]]}: <span class="text-bold">${user[item]}</span></div>
          `: '')}

          <hr class="sep"/>

          <!-- Veterinario -->
          <h4 class="title">${lng.referring_physician}</h4>
          <div>${lng.name} ${lng.and} ${lng.lastname}: <strong>${user.data.medical.medico_nome}</strong></div>
          <div>${lng.city}: <strong>${user.data.medical.medico_citta}</strong></div>
          <div>${lng.medical_office}: <strong>${user.data.medical.medico_contatto}</strong></div>
          <div>${lng.mobile_phone}: <strong>${user.data.medical.medico_contatto_cel}</strong></div>
          <div>Email: <strong>${user.data.medical.medico_contatto_email}</strong></div>
          <div>${lng.physician_reg_code}: <strong>${user.data.medical.medico_codice}</strong></div>

          <hr class="sep"/>
          <h4 class="title">${lng.surgical_interventions}</h4>
          <div innerHTML="${user.data.medical.interventi?.replace('\n','<br/>') || '-'}"></div>

          <h4 class="title">${lng.treatments_in_progress}</h4>
          <div innerHTML="${user.data.medical.trattamenti_in_corso?.replace('\n','<br/>') || '-'}"></div>

          <h4 class="title">${lng.prothesis}</h4>
          <div innerHTML="${user.data.medical.protesi_lista?.replace('\n','<br/>') || '-'}"></div>

          <hr class="sep"/>

          <h4 class="title">${lng.macro_pathologies}</h4>

          ${macro_patologie_list.map((item) => $h`
          ${user.data.medical[item.key] ? $h` <div>${item.caption} <strong>${lng.yes}</strong></div> ` : '' }
          `)}

          ${!macro_patologie() && $h`
          <div><strong>-</strong></div>
          `}

          ${(user.data.medical.altre_patologie.length > 0) && $h` 
          <h4 class="title">${lng.other.pathologies}</h4>
          <div innerHTML="${user.data.medical.altre_patologie?.replace('\n','<br/>')}"></div>
          `}

          <h4 class="title">${lng.allergies_to_drugs}</h4>

          ${user.data.medical.farmaco1 && $h`
          <div>${user.data.medical.farmaco1_caption || 'Farmaco 1'}: <strong>${lng.yes.toUpperCase()}</strong></div>
          `}
          ${user.data.medical.farmaco2 && $h`
          <div>${user.data.medical.farmaco2_caption || 'Farmaco 2'}: <strong>${lng.yes.toUpperCase()}</strong></div>
          `}
          ${user.data.medical.farmaco3 && $h`
          <div>${user.data.medical.farmaco3_caption || 'Farmaco 3'}: <strong>${lng.yes.toUpperCase()}</strong></div>
          `}
          ${(!user.data.medical.farmaco1 && !user.data.medical.farmaco2 && !user.data.medical.farmaco3) && $h`
          <div>-</div>
          `}

          <h4 class="title">${lng.food_and_generic_allergies}</h4>
          <div innerHTML="${user.data.medical.allergie?.replace('\n','<br/>') || '-'}"></div>

          <hr class="sep"/>

          <h4 class="title">${lng.medicines_in_use}</h4>
          ${user.data.medical.medicinali_in_uso.length ? $h`
          <table class="table-stripped">
            <tr><th>Farmaco</th><th>Posologia</th></tr>
            ${(user.data.medical.medicinali_in_uso || []).map( (item) => $h`
            <tr><td>${item.farmaco}</td><td>${item.posologia}</td></tr>
            `)}
          </table>
          `:''}

          <hr class="sep"/>

          ${user.data.medical.note && $h`
          <h4 class="title">${lng.notes}</h4>
          <div innerHTML="${user.data.medical.note?.replace('\n','<br/>')}"></div>
          <hr class="sep"/>
          `}

          <h4 class="title margin-top">${lng.insurance}</h4>
          <div>${lng.company}: <strong>${user.data.medical.assicurazione_compagnia}</strong></div>
          <div>${lng.policy}: <strong>${user.data.medical.assicurazione_polizza}</strong></div>
          <hr class="sep"/>
        </div>
      </div>

      `}


      <!-- ===========================
      ========= Sezione edit ========= 
      ============================ -->

      ${editMedical && $h`

      <div class="list mt-0">
        <ul>
          <h4 class="list-title">${lng.pet_data}</h4>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.name} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="name" type="text" placeholder="${lng.pet_name}" required validate value=${user.name} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.type} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="lastname" type="text" placeholder="${lng.insert} ${lng.pet_type}" required validate value=${user.lastname} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.birthdate} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="birthdate" type="date" placeholder="${lng.insert} ${lng.birthdate}" required validate value=${user.birthdate} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.sex} *</div>
              <div class="item-input-wrap">
                <select @change=${updateForm} id="sex"  required validate pattern="[^\-]">
                  <option value=""></option>
                  <option value="M">M</option>
                  <option value="F">F</option>
                </select>
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.sterilized} *</div>
              <div class="item-input-wrap">
                <select @change=${updateForm} id="sterilized" required validate pattern="[^\-]">
                  <option value=""></option>
                  <option value="Y">Si</option>
                  <option value="N">No</option>
                </select>
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>

          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.identification_number}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="chip" type="text" value="${user.chip}" placeholder="${lng.insert} ${lng.identification_number}" />
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>

          <li>
            <div class="row">
              <div class="col-40">
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${lng[translate.razza]}</div>
                    <div class="item-input-wrap">
                      <input @change=${updateForm} id="razza" type="text" placeholder="${lng.insert} ${lng[translate.razza]}" value=${user.razza}/>
                      <span class="input-clear-button"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-60">
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${lng.size}</div>
                    <div class="item-input-wrap">
                      <input @change=${updateForm} id="taglia" type="text" placeholder="${lng.insert} ${lng.size}" value=${user.taglia}/>
                      <span class="input-clear-button"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="row">
              <div class="col-40">
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${lng.hair}</div>
                    <div class="item-input-wrap">
                      <input @change=${updateForm} id="pelo" type="text" placeholder="${lng.insert} ${lng.hair}" value=${user.pelo} />
                      <span class="input-clear-button"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-60">
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${lng.color}</div>
                    <div class="item-input-wrap">
                      <input @change=${updateForm} id="colore" type="text" placeholder="${lng.insert} ${lng.color}" value=${user.colore} />
                      <span class="input-clear-button"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.weight}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="peso" type="text" placeholder="${lng.insert} ${lng.weight} (Kg)" value=${user.peso} />
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.use}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="impiego" type="text" placeholder="${lng.insert} ${lng.use}" value=${user.impiego} />
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>

          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.area_of_residence}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="zona_residenza" type="text" placeholder="${lng.insert} ${lng.area_of_residence}" value=${user.zona_residenza} />
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.particular_signs}</div>
              <div class="item-input-wrap">
                <textarea @change=${updateForm} id="segni_particolari" type="text" placeholder="${lng.insert} ${lng.particular_signs}">${user.segni_particolari}</textarea>
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>

          <h4 class="list-title">${lng.referring_physician}</h4>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">${lng.name} ${lng.and} ${lng.lastname}</div>
                <div class="item-input-wrap">
                  <input type="text" class="field" data-field="medico_nome" @change=${updateFields} 
                         placeholder="${lng.insert} ${lng.referring_physician}"/>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">${lng.physician_reg_code}</div>
                <div class="item-input-wrap">
                  <input type="text"  class="field" data-field="medico_codice"  @change=${updateFields} 
                         placeholder="${lng.regional_code_placeholder}"/>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">${lng.city}</div>
                <div class="item-input-wrap">
                  <input type="text"  class="field" data-field="medico_citta"  @change=${updateFields} 
                         placeholder="${lng.city} ${lng.referring_physician}"/>
                </div>
              </div>
            </div>
          </li>

          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label"> ${lng.phone} ${lng.medical_office}</div>
                <div class="item-input-wrap">
                  <input type="text"  class="field" data-field="medico_contatto"  @change=${updateFields} 
                         placeholder="${lng.insert} ${lng.phone.toLowerCase()} ${lng.medical_office.toLowerCase()}"/>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">${lng.mobile_phone}</div>
                <div class="item-input-wrap">
                  <input type="text"  class="field" data-field="medico_contatto_cel"  @change=${updateFields} 
                         placeholder="${lng.insert} ${lng.mobile_phone.toLowerCase()}"/>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">Email</div>
                <div class="item-input-wrap">
                  <input type="text"  class="field" data-field="medico_contatto_email"  @change=${updateFields} 
                         placeholder="${lng.insert} email"/>
                </div>
              </div>
            </div>
          </li>

          <h4 class="list-title">${lng.surgical_interventions}</h4>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-input-wrap">
                  <textarea  class="field" data-field="interventi" @change=${updateFields} 
                             placeholder="${lng.insert} ${lng.surgical_interventions}"></textarea>
                </div>
              </div>
            </div>
          </li>
          <h4 class="list-title">${lng.treatments_in_progress}</h4>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-input-wrap">
                  <textarea  class="field" data-field="trattamenti_in_corso" @change=${updateFields} 
                             placeholder="${lng.insert} ${lng.treatments_in_progress}"></textarea>
                </div>
              </div>
            </div>
          </li>
          <h4 class="list-title">${lng.prothesis}</h4>
          <li>
            <label class="item-checkbox item-content">
              <input type="checkbox" class="fieldCheckbox" data-field="protesi" @change=${updateFields} />
              <i class="icon icon-checkbox"></i>
              <div class="item-inner">
                <div class="item-title">${lng.prosthesis_wearer}</div>
              </div>
            </label>
            ${user.data.medical.protesi && $h`
            <ul>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-input-wrap">
                      <textarea  class="field" data-field="protesi_lista" @change=${updateFields} 
                                 placeholder="${lng.list}"></textarea>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            `}
          </li>

          <hr class='sep'/>
          <h4 class="list-title">${lng.macro_pathologies} <br/> <small> (${lng.select} ${lng.macro_pathologies}) </small></h4>

          ${macro_patologie_list.map((item) => $h`
          <li>
            <label class="item-checkbox item-content">
              <input type="checkbox" class="fieldCheckbox" data-field="${item.key}" @change=${updateFields}/>
              <i class="icon icon-checkbox"></i>
              <div class="item-inner">
                <div class="">${item.caption}</div>
              </div>
            </label>
          </li>
          `)}

          <h4 class="list-title">${lng.other_pathologies}</h4>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-input-wrap">
                  <textarea  class="field" data-field="altre_patologie" @change=${updateFields} 
                             placeholder="${lng.insert} ${lng.other_pathologies}"></textarea>
                </div>
              </div>
            </div>
          </li>

          <h4 class="list-title">${lng.allergies_to_drugs}</h4>
          <li>
            <label class="item-checkbox item-content">
              <input type="checkbox" class="fieldCheckbox" data-field="farmaco1" @change=${updateFields} />
              <i class="icon icon-checkbox"></i>
              <div class="item-inner">
                <div class="item-title" id="farmaco1_caption">${user.data.medical.farmaco1_caption || 'Farmaco 1'}</div>
              </div>
            </label>
          </li>
          <li>
            <label class="item-checkbox item-content">
              <input type="checkbox" class="fieldCheckbox" data-field="farmaco2" @change=${updateFields} />
              <i class="icon icon-checkbox"></i>
              <div class="item-inner">
                <div class="item-title" id="farmaco2_caption">${user.data.medical.farmaco2_caption || 'Farmaco 2'}</div>
              </div>
            </label>
          </li>
          <li>
            <label class="item-checkbox item-content">
              <input type="checkbox" class="fieldCheckbox" data-field="farmaco3" @change=${updateFields} />
              <i class="icon icon-checkbox"></i>
              <div class="item-inner">
                <div class="item-title" id="farmaco3_caption">${user.data.medical.farmaco3_caption || 'Farmaco 3'}</div>
              </div>
            </label>
          </li>

          <h4 class="list-title">${lng.food_and_generic_allergies}</h4>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-input-wrap">
                  <textarea  class="field" data-field="allergie" @change=${updateFields} 
                             placeholder="${lng.insert} ${lng.food_and_generic_allergies}"></textarea>
                </div>
              </div>
            </div>
          </li>

          <hr class='sep'/>
          <h4 class="list-title">
            ${lng.medicines_in_use}
            <button data-popup=".popup-add-medicine" class="button button-fill button-inline color-secondary button-small popup-open" style="float: right">
              <i class="f7-icons">plus</i>
              ${lng.add}
            </button>
          </h4>
          <li>
            <div class="block">
              <table class="field" data-field="medicinali_in_uso" width="100%">
                <thead>
                  <tr><th>Farmaco</th><th>Posologia</th><th></th><th></th></tr>
                </thead>
                <tbody id='tbl-medicinali'></tbody>
              </table>
            </div>
          </li>

          <hr class='sep'/>
          <h4 class='list-title'>${lng.notes}</h4>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-input-wrap">
                  <textarea class="field" data-field="note" @change=${updateFields} 
                            placeholder="${lng.insert} ${lng.notes}"></textarea>
                </div>
              </div>
            </div>
          </li>

          <hr class='sep'/>
          <h4 class="list-title">${lng.insurance}</h4>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">${lng.company}</div>
                <div class="item-input-wrap">
                  <input type="text" class="field" data-field="assicurazione_compagnia" @change=${updateFields} 
                         placeholder="${lng.insert} ${lng.company}"/>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">${lng.policy}</div>
                <div class="item-input-wrap">
                  <input type="text" class="field" data-field="assicurazione_polizza" @change=${updateFields} 
                         placeholder="${lng.insert} ${lng.policy}"/>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      `}

      <!-- ===== Sezione immagini e documenti ===== -->

      <div class="image-gallery-container">
        ${(user.data.medical.images.filter((itm) => itm.viewOnMedicalRecords)).map((item, index) => $h`
        <div style="position: relative" class="mylist">
          <img src="${item.src}" id="img_${
                 index
               }" data-type="images" data-id="${item.src}" @click=${clickOnDocument} /> 
          <div class="qrcode-name">${item.name || ''}</div>
        </div>
        `)}
      </div>
      <div class="image-gallery-container">
        ${(user.data.medical.qrcodes.filter((item) => item.viewOnMedicalRecords)).map((item, index) => $h`
        <div style="position: relative" class="mylist">
          <img src="${item.src}" id="qrc_${
                 index
               }" data-type="qrcodes" data-id="${item.id}" @click=${clickOnDocument} /> 
          <div class="qrcode-name">${item.name || ''}</div>
        </div>
        `)}
      </div>
      <div class="documents-container">
        ${(user.data.medical.documents.filter((item) => item.viewOnMedicalRecords)).map((item, index) => $h`
        <div class="document mylist" id="doc_${
               index
             }" data-type="documents" data-id="${item.url}" @click=${clickOnDocument}>
          <img src="static/pdf-icon.png"/>
          <div class="document-caption">${item.name}</div>
        </div>
        `)}
      </div>

      ${editMedical && $h`
      <div class="block">
        <button class="button button-large button-round button-outline color-secondary popup-open" data-popup=".popup-import-document">
          <i class="f7-icons left">square_arrow_right</i>
          ${lng.import_document}
        </button>
      </div>
      `}
    </div>

    <!-- Popup Import Document -->
    <div class="popup popup-tablet-fullscreen popup-import-document" 
         @popup:closed=${clearDocumentList}>
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="left">
                <a class="link popup-close">${lng.cancel}</a>
              </div>
              <div class="title">${lng.import_document}</div>
              <div class="right">
                <a class="link popup-close button button-fill button-round btn-import color-secondary disabled" @click=${importDocuments}>${lng.import}</a>
              </div>
            </div>
          </div>
          <div class="page-content"  style="overflow: auto">
            ${ !((user.data.medical.images.filter((e) => !e.viewOnMedicalRecords)).length || 
            (user.data.medical.qrcodes.filter((e) => !e.viewOnMedicalRecords)).length || 
            (user.data.medical.documents.filter((e) => !e.viewOnMedicalRecords).length)) ? $h`
            <div class="display-flex flex-direction-column justify-content-center align-items-center h-90">
              <img src="static/notfound.svg" width="150" />
              <h4 class="text-align-center">
                ${lng.import_document_empty}
              </h4>
              <a class="button button-link color-blue popup-close" href="/documents/?viewOnMedicalRecords=yes">${lng.document_create}</a>
              <button class="button button-link color-gray popup-close">${lng.close}</button>
            </div>
            ` : $h`

            <div class="list media-list mt-0">
              <ul>
                ${user.data.medical.images.filter((e) => !e.viewOnMedicalRecords).map((e) => $h`
                <li>
                  <div class="item-content">
                    <div class="item-media">
                      <img class="cover" src="${e.src}" width="120" height="120"/>
                    </div>
                    <div class="item-inner">
                      <div class="item-title-row">
                        <div>${e.name}</div>
                      </div>
                      <div class="item-subtitle">
                        <label class="checkbox">
                          <input class="importDocument" @change=${enableBtnImport} data-type="images" data-id="${e.src}" type="checkbox" />
                          <i class="icon-checkbox float-right"></i>
                          <span class="padding-right">${lng.import}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </li>
                `)}
                ${user.data.medical.qrcodes.filter((e) => !e.viewOnMedicalRecords).map((e) => $h`
                <li>
                  <div class="item-content">
                    <div class="item-media">
                      <img src="${e.src}" width="120"/>
                    </div>
                    <div class="item-inner">
                      <div class="item-title-row">
                        <div>${e.name}</div>
                      </div>
                      <div class="item-subtitle">
                        <label class="checkbox">
                          <input class="importDocument" @change=${enableBtnImport} data-type="qrcodes" data-id="${e.id}" type="checkbox" />
                          <i class="icon-checkbox float-right"></i>
                          <span class="padding-right">${lng.import}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </li>
                `)}
                ${user.data.medical.documents.filter((e) => !e.viewOnMedicalRecords).map((e) => $h`
                <li>
                  <div class="item-content">
                    <div class="item-media">
                      <img src="static/pdf-icon.png" width="120"/>
                    </div>
                    <div class="item-inner">
                      <div class="item-title-row">
                        <div>${e.name}</div>
                      </div>
                      <div class="item-subtitle">
                        <label class="checkbox">
                          <input class="importDocument" @change=${enableBtnImport} data-type="documents" data-id="${e.url}" type="checkbox" />
                          <i class="icon-checkbox float-right"></i>
                          <span class="padding-right">${lng.import}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </li>
                `)}
              </ul>
            </div>

            <div class="block text-align-center">
              <a class="button button-large button-outline button-round color-secondary popup-close" href="/documents/?viewOnMedicalRecords=yes">
                <i class="f7-icons left">plus</i>
                ${lng.create_new}
              </a>
            </div>

            `}
          </div>
        </div>
      </div>
    </div>


    <!-- Popup Insert PIN 
    <div class="popup popup-tablet-fullscreen popup-safe display-flex justify-content-center align-items-center flex-direction-column">
      <div class="block text-align-center">
        ${lng.insert_pin_message}
      </div>
      <div class="unselectable" style="width: 100%; max-width: 380px;">
        <div class="row text-align-center" style="max-width: 250px; margin: 0 auto; padding: 25px 0">
          <div class="col">
            <div class="point point-0"></div>
          </div>
          <div class="col">
            <div class="point point-1"></div>
          </div>
          <div class="col">
            <div class="point point-2"></div>
          </div>
          <div class="col">
            <div class="point point-3"></div>
          </div>
        </div>
        <div id="safe-message" class="text-align-center text-color-red invisible">
          ${lng.pin_error_message} <br/> ${lng.attempts_left} ${safeAttempts}
        </div>
        <div class="block text-align-center">
          <div class="row">
            <div class="col number-key safe" data-number="1">1</div>
            <div class="col number-key safe" data-number="2">2</div>
            <div class="col number-key safe" data-number="3">3</div>
          </div>
          <div class="row">
            <div class="col number-key safe" data-number="4">4</div>
            <div class="col number-key safe" data-number="5">5</div>
            <div class="col number-key safe" data-number="6">6</div>
          </div>
          <div class="row">
            <div class="col number-key safe" data-number="7">7</div>
            <div class="col number-key safe" data-number="8">8</div>
            <div class="col number-key safe" data-number="9">9</div>
          </div>
          <div class="row">
            <div class="col number-key safe" data-number="null"></div>
            <div class="col number-key safe" data-number="0">0</div>
            <div class="col number-key safe" data-number="back"><i class="f7-icons" data-number="back">delete_left</i></div>
          </div>
        </div>
      </div>
      <button class="button button-link text-color-gray" @click=${safeCancel}>${lng.cancel}</button>
      <button class="button button-link text-color-primary" @click=${recoveryPIN}>${lng.recoveryPINMessage}</button>
    </div> -->


    <!-- Popup Add Medicine -->
    <div class="popup popup-add-medicine" @popup:opened=${popupAddMedicineOpened} @popup:closed=${popupAddMedicineClosed}>
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="title">${lng.medicines_in_use}</div>
              <div class="right">
                <!-- Link to close popup -->
                <a class="link popup-close">${lng.cancel}</a>
              </div>
            </div>
          </div>

          <div class="page-content display-flex flex-direction-column align-items-center justify-content-center">
            <div class="list no-hairlines" style="width: 100vw">
              <ul>
                <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">Farmaco</div>
                    <div class="item-input-wrap">
                      <input type="text" required validate id="add-farmaco" />
                      <span class="input-clear-button"></span>
                    </div>
                  </div>
                </li>
                <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">Posologia</div>
                    <div class="item-input-wrap">
                      <input type="text" required validate id="add-posologia" />
                      <span class="input-clear-button"></span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <input type="hidden" id="add-idx"/>
            <button class="button button-large button-outline button-round color-secondary" 
                    style="width: 90vw" @click=${addMedicine}>${lng.save}</button>
          </div>
        </div>
      </div>
    </div>


  </div>
`
    }
    );

          case 75:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
})();